export default function ($) {
  const blockSliderSwiper = new Swiper('.js-block-slider-swiper', {
    loop: true,
    spaceBetween: 32,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })

  const partnersSwiper = new Swiper('.js-partners-swiper', {
    slidesPerView: '2',
    spaceBetween: 32,
    loop: false,
    pagination: {
      el: '.swiper-pagination-partners-slider',
      clickable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: '3',
      },
      768: {
        slidesPerView: '4',
      },
      1024: {
        slidesPerView: '5',
        spaceBetween: 56,
      },
    },
  });
}
